module.exports = __webpack_public_path__ + "81b4c73bae2f6de2691fb5b835b9a9c5.jpg";